import AdminProductsBase from "./AdminProductsBase";

export default function AdminNewInProducts() {
  return <AdminProductsBase filterType="new" />;
}
